import React, { useState } from 'react';
import styled from 'styled-components';
import { setToken } from './token.service';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import environment from './environment';


const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
  background: #ececec;
  font-family: 'Arial', sans-serif;
`;

const FormWrapper = styled.div`
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 300px;
  padding: 40px;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 2rem;
  color: #333;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
  &:focus {
    outline: none;
    border-color: #6e8efb;
    box-shadow: 0 0 8px rgba(110, 142, 251, 0.5);
  }
`;

const Button = styled.button`
  background: linear-gradient(135deg, #6e8efb, #a777e3);
  color: white;
  font-size: 1rem;
  padding: 10px;
  border: none;
  border-radius: 5px;
  width: 100%;
  cursor: pointer;
  margin-top: 10px;
  transition: background 0.3s;
  &:hover {
    background: linear-gradient(135deg, #a777e3, #6e8efb);
  }
`;

// const Link = styled.a`
//   display: block;
//   margin-top: 20px;
//   color: #6e8efb;
//   text-decoration: none;
//   font-size: 0.9rem;
//   &:hover {
//     text-decoration: underline;
//   }
// `;

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Email:', email);
    console.log('Password:', password);

    try {
        const response = await fetch(`${environment.api_url}/api/resume-analyser/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email, password })
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        setToken(data.baseauth);
        navigate('/');
    } catch (error) {
        console.error('Error:', error);
        message.error(`Incorrect email or password`);
    }
};

  return (
    <Container>
      <FormWrapper>
        <Title>Login</Title>
        <form onSubmit={handleSubmit}>
          <Input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <Input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Button type="submit">Log In</Button>
        </form>
        {/* <Link href="#">Forgot Password?</Link> */}
        {/* <Link href="#">Create an Account</Link> */}
      </FormWrapper>
    </Container>
  );
};

export default Login;
